import { render } from "./ExpedicionesCargarCamionPage.vue?vue&type=template&id=3d2b7911&scoped=true"
import script from "./ExpedicionesCargarCamionPage.vue?vue&type=script&lang=js"
export * from "./ExpedicionesCargarCamionPage.vue?vue&type=script&lang=js"

import "./ExpedicionesCargarCamionPage.vue?vue&type=style&index=0&id=3d2b7911&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2b7911"]])

export default __exports__